import BaseModelAPI from '../BaseModelAPI';

export default class PutAwayCategory extends BaseModelAPI {
	static entity = 'putawaycategory';
	static entityName = 'putawaycategory';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}